<template>
  <article class="content-container-grow" style="position: relative">
    <div class="coin-group-container max-width">
      <UiRadioSlide
        :comboItems="coinComboList"
        @onClick="coinListClick"
      ></UiRadioSlide>
    </div>
    <section class="chart-header-container">
      <UiArticleTitle
        class="content-mg max-width"
        :explainTitle="$t(sectionTitle.kibotChart.sub)"
        :mainTitle="ticker"
        :symbol="true"
        :symbolIcon="getCoinInfo?.icon"
      />
      <button
        class="btn-toggle"
        @click="statusHandler"
        :class="{ close: isClose }"
      >
        <!-- {{ t('chart1.all') }} {{ btnStatus }} -->
        {{ t(btnStatus) }}
      </button>
    </section>
    <section class="chart kibot-chart__list-wrapper">
      <Draggable
        ref="draggableRef"
        :list="accordionList"
        item-key="name"
        class="list-group"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
        handle=".handle"
      >
        <template #item="{ element }">
          <UiAccordion
            :title="$t(element.title)"
            :tooltipMsg="element.tooltipMsg"
            :icon="element.icon"
            :iconStyle="element.iconStyle"
            :dataKey="element.key"
            :viewPage="element.viewPage"
            :accordionList="accordionList"
            :isOpen="element.open"
            :class="{ active: element.open }"
            :isFullscreen="fullscreenState[element.key]"
            :strategyTitle="element.strategyTitle"
            :lightDarkMode="element.lightDarkMode"
            @change-mode="handleModeChange"
            :ticker="ticker"
          >
            <!-- <ClientOnly> -->
            <section v-html="element.content" v-if="element.open"></section>
            <!-- <lazy-charts-cue          @mounted="renderHandler(element.key)" :ticker="ticker"  v-if="element.open && element.key == 'cue'" ></lazy-charts-cue> -->
            <lazyScoreChart
              @mounted="renderHandler(element.key)"
              :ticker="ticker"
              v-if="
                element.open &&
                element.key == 'score' &&
                props.currentStrategy === 'explorer'
              "
            ></lazyScoreChart>
            <lazyStrategy
              v-if="
                element.open &&
                element.key === 'strategy' &&
                props.currentStrategy
              "
              :isDashBoard="false"
              size="small"
              :currentStrategy="props.currentStrategy"
            ></lazyStrategy>
            <lazyMetaChart
              @mounted="renderHandler(element.key)"
              :ticker="ticker"
              v-if="
                (element.open && element.key == 'meta') ||
                (element.open && element.isStrategy)
              "
              :isFullscreen="fullscreenState[element.key]"
              @fullscreen-toggle="handleFullscreenToggle(element.key, $event)"
              :key="ticker"
              :subscribeInfo="chartSubScribeInfo.subsc_type"
              :model="element.key"
              :currentStrategy="props.currentStrategy"
              :theme="
                activeChartKey === 'meta' || activeChartKey === 'kibotZone'
                  ? currentThemeMode
                  : null
              "
            ></lazyMetaChart>
            <lazyMetaChart
              @mounted="renderHandler(element.key)"
              :ticker="ticker"
              v-if="
                element.open &&
                element.key == 'alpha' &&
                props.currentStrategy === 'explorer'
              "
              :isFullscreen="fullscreenState[element.key]"
              @fullscreen-toggle="handleFullscreenToggle(element.key, $event)"
              :key="ticker"
              :subscribeInfo="chartSubScribeInfo.subsc_type"
              model="alpha"
              :theme="activeChartKey === 'alpha' ? currentThemeMode : null"
            ></lazyMetaChart>
            <lazyTradingview
              @mounted="renderHandler(element.key)"
              :ticker="ticker"
              v-if="
                element.open &&
                element.key == 'trading_view' &&
                props.currentStrategy === 'explorer'
              "
            ></lazyTradingview>
            <!-- </ClientOnly> -->
          </UiAccordion>
        </template>
      </Draggable>
    </section>
    <AlertMsg v-show="alertMsg.visible" />
  </article>
</template>

<script setup>
import Draggable from "vuedraggable";
import UiRadioSlide from "@/components/ui/RadioSlide.vue";
import UiArticleTitle from "@/components/ui/ArticleTitle.vue";
import UiAccordion from "@/components/ui/Accordion.vue";
import score_ico from "@/assets/images/icons/chart/dark/score_chart_ico.svg";
import tick_ico from "@/assets/images/icons/chart/dark/meta_chart_ico.svg";
import trading_ico from "@/assets/images/icons/chart/dark/trading_chart_ico.svg";
import strategy_ico from "@/assets/images/icons/chart/dark/strategy_chart_ico.svg";
import chart_ico from "@/assets/images/components/common/chart/chart_ico.svg";
import arrow_ico from "@/assets/images/icons/arrow_top_ico.svg";
import chart_meta from "@/components/explanation/chart_meta.vue";
import chart_kibot_zone from "@/components/explanation/chart_kibot_zone.vue";
import chart_cross from "@/components/explanation/chart_cross.vue";
import chart_double from "@/components/explanation/chart_double.vue";
import chart_alpha from "@/components/explanation/chart_alpha.vue";
import chart_score from "@/components/explanation/chart_score.vue";
import chart_tradingview from "@/components/explanation/chart_tradingview.vue";
import {
  computed,
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onUnmounted,
  defineProps,
  reactive,
} from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
const lazyMetaChart = defineAsyncComponent(() =>
  import("@/components/chart/meta-chart/MetaChartCopy.vue")
);
const lazyStrategy = defineAsyncComponent(() =>
  import("@/components/dashboard/StrategyChart.vue")
);
const lazyScoreChart = defineAsyncComponent(() =>
  import("@/components/chart/score-chart/ScoreChart.vue")
);
const lazyTradingview = defineAsyncComponent(() =>
  import("@/components/chart/tradingview/TradingView.vue")
);
import { getRisingUserInfo } from "@/api/authToken";
import AlertMsg from "@/components/bot/AlertMsg.vue";
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n({ useScope: "global" });
const store = useStore();
const alertMsg = computed(() => store.state.usePopupList.alertMsg);
const route = useRoute();
const router = useRouter();
const coinCombo = ref([]);
const coinComboList = ref({
  isActive: false,
  title: "chart1.selectCoin",
  titleStyle: {
    width: "250px",
    margin: "0 auto",
  },
  items: coinCombo.value,
});

const props = defineProps({
  currentStrategy: String,
});

const tickerDefault = ref("");
let ticker = ref("");
const sectionTitle = ref({
  kibotChart: {
    main: "ETHUSDT",
    sub: "menu.kibotChart",
  },
});
const getCoinInfo = ref("");

const draggableRef = ref(null);
const dragging = ref(false);
let accordionList = ref([]);
const renderRef = ref({
  cue: false,
  meta: false,
  score: false,
  trading_view: false,
});

let userInfo = computed(() => store.state.userInfo.risingUserInfo);

let chartSubScribeInfo = computed(() => store.state.userInfo.chartInfo);

// const isFullscreen = ref(false);

const metaIsFullscreen = ref(false);
const alphaIsFullscreen = ref(false);
const kibotZoneIsFullScreen = ref(false);

const fullscreenState = reactive({
  meta: false,
  alpha: false,
  kibotZone: false,
  double: false, // 앞으로 추가될 상태
  cross: false, // 앞으로 추가될 상태
});

const handleFullscreenToggle = (key, isFull) => {
  if (key in fullscreenState) {
    fullscreenState[key] = isFull;
  }
};

const currentThemeMode = ref("null");
const activeChartKey = ref(null);

const handleModeChange = (mode, dataKey) => {
  currentThemeMode.value = mode;

  console.log(22, mode);

  activeChartKey.value = dataKey;
};

function renderHandler(key) {
  renderRef.value[key] = true;
  const renderStatus = Object.values(renderRef.value);
  if (renderStatus.every((ob) => ob)) {
    scrollHandler(route.query.menuName);
  }
}
function scrollHandler(type) {
  if (alertMsg.value.visible) {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    switch (type) {
      default:
        if (draggableRef.value) {
          const fi = draggableRef.value.list.findIndex((ob) => ob.key === type);
          const $dom = draggableRef.value.$el.children[fi];

          if ($dom) {
            const top =
              draggableRef.value.$el.children[fi].getBoundingClientRect().top -
              121 +
              window.scrollY;
            window.scrollTo({ top, behavior: "smooth" });
          }
        }
        break;
    }
  }
}

onMounted(async () => {
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
      }
      await store.dispatch("getCoinList/fetchCoin");
      coinCombo.value = await store.dispatch("getCoinList/getCoinComboList");
    } else {
      openAlertMsg(422);
      return;
    }
  } else {
    openAlertMsg(422);
    return;
  }
  ticker.value =
    route.query.ticker ||
    (await store.dispatch("getCoinList/getChartSubscribeDefaultCoin"));

  requestAnimationFrame(() => {
    const allItems = {
      meta: {
        key: "meta",
        title: `${ticker.value}USDT`,
        content: "",
        tooltipMsg: `Meta description`,
        icon: tick_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_meta,
        lightDarkMode: "dark",
      },
      kibotZone: {
        key: "kibotZone",
        strategyTitle: `1%`,
        isStrategy: true,
        title: `${ticker.value}USDT`,
        content: "",
        tooltipMsg: `kibotZone description`,
        icon: tick_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_kibot_zone,
        lightDarkMode: "dark",
      },
      cross: {
        key: "cross",
        strategyTitle: `${t("strategy.cross.title")}`,
        isStrategy: true,
        title: `${ticker.value}USDT`,
        content: "",
        tooltipMsg: `cross description`,
        icon: tick_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_cross,
      },
      double: {
        key: "double",
        strategyTitle: "Double",
        isStrategy: true,
        title: `${ticker.value}USDT`,
        content: "",
        tooltipMsg: `double description`,
        icon: tick_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_double,
      },
      alpha: {
        key: "alpha",
        title: `${ticker.value}USDT`,
        content: "",
        tooltipMsg: `Alpha description`,
        icon: tick_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_alpha,
        lightDarkMode: "dark",
      },
      strategy: {
        key: "strategy",
        title: "strategy.strategyChart",
        content: "",
        icon: tick_ico,
        iconStyle: {
          width: "25px",
        },
        open: true,
      },
      score: {
        key: "score",
        title: "chart1.scoreChart",
        content: "",
        tooltipMsg: `Score description`,
        icon: score_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_score,
      },
      trading_view: {
        key: "trading_view",
        title: "chart1.tradingView",
        content: "",
        tooltipMsg: `Trading description`,
        icon: trading_ico,
        iconStyle: {},
        open: true,
        viewPage: chart_tradingview,
      },
    };

    const list = [];

    if (props.currentStrategy === "kibotZone") {
      // 'kibotZone' 전략일 때의 구성
      list.push(allItems.strategy);
      list.push(allItems.kibotZone);
    } else if (props.currentStrategy === "cross") {
      // 'cross' 전략일 때의 구성
      list.push(allItems.strategy);
      list.push(allItems.cross);
    } else if (props.currentStrategy === "double") {
      // 'double' 전략일 때의 구성
      list.push(allItems.strategy);
      list.push(allItems.double);
    } else {
      // 기본 구성 (props.currentStrategy가 없거나 일치하는 조건이 없을 때)
      list.push(allItems.meta);
      list.push(allItems.alpha);

      // 25/09/17~25/10/17 기간동안만!!!!
      // if (
      //   chartSubScribeInfo.value &&
      //   chartSubScribeInfo.value.subsc_type != "plan99"
      // ) {
      //   list.push(allItems.score);
      // }

      // 25/09/17~25/10/17 기간동안만!!!!
      list.push(allItems.score);

      list.push(allItems.trading_view);
    }

    accordionList.value = list;

    //// accordionList.value = JSON.parse(localStorage.getItem('chart_accordion')) || [
    // accordionList.value = [
    //   {
    //     key: "meta",
    //     title: `${ticker.value}USDT`,
    //     content: "",
    //     tooltipMsg: `Meta description`,
    //     icon: tick_ico,
    //     iconStyle: {},
    //     open: true,
    //     viewPage: chart_meta,
    //   },
    //   // {
    //   //     key         : 'score',
    //   //     title       : 'Score Chart',
    //   //     content     : '',
    //   //     tooltipMsg  : `Score description`,
    //   //     icon        : score_ico,
    //   //     iconStyle   : {},
    //   //     open        : true,
    //   //     viewPage    : chart_score,
    //   // },
    // ];
    // accordionList.value.push({
    //   key: "alpha",
    //   title: `${ticker.value}USDT`,
    //   content: "",
    //   tooltipMsg: `Alpha description`,
    //   icon: tick_ico,
    //   iconStyle: {},
    //   open: true,
    //   viewPage: chart_alpha,
    // });
    // if (
    //   chartSubScribeInfo.value &&
    //   chartSubScribeInfo.value.subsc_type != "plan99"
    // ) {
    //   accordionList.value.push({
    //     key: "score",
    //     title: "chart1.scoreChart",
    //     content: "",
    //     tooltipMsg: `Score description`,
    //     icon: score_ico,
    //     iconStyle: {},
    //     open: true,
    //     viewPage: chart_score,
    //   });
    // }
    // accordionList.value.push({
    //   key: "trading_view",
    //   title: "chart1.tradingView",
    //   content: "",
    //   tooltipMsg: `Trading description`,
    //   icon: trading_ico,
    //   iconStyle: {},
    //   open: true,
    //   viewPage: chart_tradingview,
    // });
  });
});
onUnmounted(() => {
  store.commit("usePopupList/toggleAlertMsg", { visible: false });
});

watch(userInfo, async (newVal) => {
  // console.log('userInfo newVal',newVal);
  if (userInfo.value) {
    if (Object.keys(userInfo.value).length != 0) {
      if (userInfo.value.chart_subsc_wht == "N") {
        openAlertMsg("chartPurmission");
      }
      await store.dispatch("getCoinList/fetchCoin");
      coinCombo.value = await store.dispatch("getCoinList/getCoinComboList");
    } else {
      openAlertMsg(422);
      return;
    }
  } else {
    openAlertMsg(422);
    return;
  }
});

watch(coinCombo, (newVal) => {
  coinComboList.value.items = newVal;
});

watch(ticker, (newTicker, oldTicker) => {
  ticker.value = newTicker;

  currentThemeMode.value = "dark"; // 또는 기본 테마값
  activeChartKey.value = null;

  getCoinInfo.value = coinComboList.value.items.find(
    (option) => option.key == ticker.value
  );

  if (accordionList.value && accordionList.value.length > 0) {
    accordionList.value.forEach((item) => {
      // isStrategy가 있는 전략 차트나, key가 'meta' 또는 'alpha'인 일반 차트의 title을 업데이트
      if (
        item.isStrategy ||
        ["meta", "alpha", "kibotZone", "cross", "double"].includes(item.key)
      ) {
        item.title = `${newTicker}USDT`;
      }
    });
  }
});

watch(
  () => route.query.menuName,
  (newVal) => {
    scrollHandler(newVal);
  }
);

// const coinListClick = async (item) => {
//   try {
//     let result = await getRisingUserInfo();

//     console.log(11, result);

//     if (!result.error) {
//       console.log(22, chartSubScribeInfo.value.subsc_type);

//       coinComboList.value.isActive = false;
//       ticker.value = item.selected;
//       store.commit("getCoinList/setDefaultCoin", ticker.value);
//       accordionList.value.find(
//         (chart) => chart.key == "meta"
//       ).title = `${ticker.value}USDT`;

//       const queryParams = {
//         ticker: ticker.value,
//       };

//       if (props.currentStrategy) {
//         queryParams.currentStrategy = props.currentStrategy;
//       }

//       router.push({
//         path: "/kibot/chart",
//         query: queryParams,
//       });
//     } else {
//       // console.log('not loggined');
//     }
//   } catch (error) {
//     await store.dispatch("userInfo/getChartSubscribeInfo", []);
//     // console.log('not loggined');
//   }
// };
const coinListClick = async (item) => {
  coinComboList.value.isActive = false;

  if (store.state.userInfo.userInfo) {
    ticker.value = item.selected;
    store.commit("getCoinList/setDefaultCoin", ticker.value);
  } else {
    console.log("로그인이 필요합니다.");
  }
};

const checkMove = async (e) => {
  // const list = e.relatedContext.list;
  // const stringifiedList = JSON.stringify(list);
  // localStorage.setItem('chart_accordion', stringifiedList);
};
let isClose = ref(true);
let btnStatus = ref("chart1.allClose");
const statusHandler = () => {
  btnStatus.value = isClose.value ? "chart1.allOpen" : "chart1.allClose";
  isClose.value = isClose.value ? false : true;
  accordionList.value.forEach((ob) => {
    ob.open = isClose.value;
  });
};

function openAlertMsg(code) {
  store.commit("usePopupList/toggleAlertMsg", { visible: true, code: code });
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/kibot/chart.scss";
</style>
